import type { TheWordGame } from "@packages/sdk";

export const calculateWon = ({
  won,
  matrix,
}: {
  won?: boolean;
  matrix: TheWordGame["summary"]["matrix"];
}): boolean =>
  won ??
  !(
    matrix?.[matrix?.length - 1]?.some(
      (val) => val !== "in_word_in_position",
    ) ?? true
  );
